import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { convertFieldToString } from "../../utils/convertFieldToString";
import { getFieldFromString } from "../../utils/getFieldFromString";
export var useSessionState = function useSessionState(storageKey, params) {
  var _ref = params || {},
    defaultValue = _ref.defaultValue,
    stateToStore = _ref.stateToStore,
    storeToState = _ref.storeToState;
  var _useState = useState(defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    var stashedValue = sessionStorage.getItem(storageKey);
    var value = stashedValue ? (storeToState || getFieldFromString)(stashedValue) : defaultValue;
    setState(value !== null && value !== void 0 ? value : undefined);
  }, []);
  useEffect(function () {
    sessionStorage.setItem(storageKey, (stateToStore || convertFieldToString)(state));
  }, [state]);
  return [state, setState];
};